// The control tab „Teilen“ (ADR-0084 decisions 14 and 15): the switch and the
// removal of a reported link. State and count are rendered by the server, so
// a switch reloads the page rather than patching it.

import { axios } from './vendor.js';
import { germanDate, tokenFrom } from './share_wording.js';

const NOT_FOUND = 'Kein Link mit diesem Token.';

function part(id) {
    return document.getElementById(id);
}

function hideModal(id) {
    bootstrap.Modal.getOrCreateInstance(part(id)).hide();
}

function say(text) {
    part('sharingMessage').textContent = text;
}

function showDetails(details) {
    part('sharingDetailTitle').textContent = details.conversation_title;
    part('sharingDetailUser').textContent = details.user_id;
    part('sharingDetailCreated').textContent = germanDate(details.created_at);
    part('sharingDetailExpires').textContent = details.expires_at
        ? germanDate(details.expires_at) + (details.expired ? ' (abgelaufen)' : '')
        : 'unbefristet';
    part('sharingDetailTurns').textContent = String(details.turn_count);
    part('sharingDetails').classList.remove('d-none');
}

function errorText(error) {
    return error?.response?.data?.error || NOT_FOUND;
}

export function initControlSharing() {
    const root = part('controlSharing');
    const shareUrl = token => root.dataset.shareUrl.replace('TOKEN', encodeURIComponent(token));
    let token = null;

    part('sharingSwitchConfirm').addEventListener('click', async () => {
        const active = root.dataset.targetActive === 'true';
        await axios.post(root.dataset.switchUrl, { active });
        window.location.reload();
    });

    part('sharingInspectBtn').addEventListener('click', async () => {
        say('');
        part('sharingDetails').classList.add('d-none');
        token = tokenFrom(part('sharingTokenInput').value);
        if (!token) return;
        try {
            showDetails((await axios.get(shareUrl(token))).data);
        } catch (error) {
            say(errorText(error));
        }
    });

    part('sharingRemoveConfirm').addEventListener('click', async () => {
        try {
            await axios.delete(shareUrl(token));
            part('sharingDetails').classList.add('d-none');
            part('sharingTokenInput').value = '';
            say('Entfernt.');
        } catch (error) {
            say(errorText(error));
        } finally {
            hideModal('sharingRemoveModal');
        }
    });
}
